import React from 'react';
import { HeaderContext } from '../contexts/header-context';
export function useHeaderExperimentFeatures() {
  const context = React.useContext(HeaderContext);
  return context === null || context === void 0 ? void 0 : context.headerExperimentFeatures;
}
//# sourceMappingURL=use-header-experiment-features.js.map